var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoKeidgePretoFilm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1234,
    height: 500,
    viewBox: "0 0 1234 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M756.22 425.269H808.764V437.616H771.538V456.182H805.979V468.158H771.538V499.442H756.127V425.269H756.22Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M819.068 425.269H834.478V499.442H819.068V425.269Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M848.775 425.269H864.185V486.817H896.769V499.535H848.775V425.362V425.269Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M906.146 425.269H927.404L944.672 479.483L962.588 425.269H983.476V499.442H968.065V446.342L949.963 499.442H937.616L919.978 446.156V499.442H906.146V425.269Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8385 44.8385H216.487V0H0V500H216.487V455.161H44.8385V44.8385Z",
    fill: "#1E1E1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.9 0V44.8385H1188.54V455.161H1016.9V500H1233.38V0H1016.9Z",
    fill: "#1E1E1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M581.229 140.271H572.224V187.245H581.229C623.84 187.245 645.006 208.411 645.006 251.021C645.006 293.632 623.84 314.798 581.229 314.798H572.224V361.771H581.229C652.061 361.771 691.979 325.195 691.979 251.021C691.979 176.847 652.061 140.271 581.229 140.271Z",
    fill: "#1E1E1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M826.773 273.672H865.113C865.113 341.905 756.127 341.905 756.127 250.092C756.127 158.28 784.348 179.446 826.773 179.446V132.38C756.127 132.38 709.061 179.446 709.061 250.092C709.061 368.084 827.98 394.634 876.717 341.255L912.087 361.121V226.606H826.68V273.672H826.773Z",
    fill: "#1E1E1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.7 226.513H976.049V186.223H1082.34V139.157H928.982V273.765L1055.7 273.672V226.513Z",
    fill: "#1E1E1C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 361.029H1082.34V313.962H1018.01L1017.82 361.029Z",
    fill: "#1E1E1C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M342.926 275.251L469.644 275.158V228.092H389.993V187.709H496.287V140.643H342.926V275.251Z",
    fill: "#1E1E1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.669 362.607H496.287V315.54H344.04L343.669 362.607Z",
    fill: "#1E1E1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.013 140.271H151.04V361.771H198.013V140.271Z",
    fill: "#1E1E1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.094 140.271L200.613 251.021L272.094 361.771H326.773L255.663 251.021L326.773 140.271H272.094Z",
    fill: "#1E1E1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M557.928 140.271H510.769V185.852H557.928V140.271Z",
    fill: "#1E1E1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M557.928 199.499H510.769V361.771H557.928V199.499Z",
    fill: "#1E1E1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKeidgePretoFilm);
export default __webpack_public_path__ + "static/media/Logo-Keidge_preto-film.40d8cefbc7332b48baa909484d0df7ac.svg";
export { ForwardRef as ReactComponent };